import PropTypes from "prop-types";
import React, { useRef } from "react";
import { closeSnackbar, SnackbarProvider as NotistackProvider } from "notistack";
// @mui
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
// context
import { useSettingsContext } from "src/context/settings";
// components
import Iconify from "src/components/iconify";
import Image from "src/components/image";
//
import { StyledIcon, StyledNotistack } from "./styles";

// ----------------------------------------------------------------------

export default function SnackbarProvider({ children }) {
    const settings = useSettingsContext();

    const isRTL = settings.themeDirection === "rtl";

    const notistackRef = useRef(null);

    return (
        <NotistackProvider
            ref={notistackRef}
            maxSnack={5}
            preventDuplicate
            autoHideDuration={4000}
            TransitionComponent={isRTL ? Collapse : undefined}
            variant="success" // Set default variant
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            iconVariant={{
                info: (
                    <StyledIcon color="info">
                        <Image src="/assets/icon/system/ic_info.svg" alt="info" objectFit="contain" disabledEffect visibleByDefault/>
                    </StyledIcon>
                ),
                success: (
                    <StyledIcon color="success">
                        <Image src="/assets/icon/system/ic_success.svg" alt="success" objectFit="contain" disabledEffect visibleByDefault/>
                    </StyledIcon>
                ),
                warning: (
                    <StyledIcon color="warning">
                        <Image src="/assets/icon/system/ic_warning.svg" alt="warning" objectFit="contain" disabledEffect visibleByDefault/>
                    </StyledIcon>
                ),
                error: (
                    <StyledIcon color="warning">
                        <Image src="/assets/icon/system/ic_alert.svg" alt="alert" objectFit="contain" disabledEffect visibleByDefault/>
                    </StyledIcon>
                ),
                successUpdate: (
                    <Iconify icon="eva:checkmark-circle-2-fill" minWidth={20} color="#35C058" mr="10px" mt="3px" />
                ),
                failUpdate: (
                    <Iconify icon="eva:info-fill" minWidth={20} color="error.main" mr="10px" mt="3px" />
                )
            }}
            Components={{
                default: StyledNotistack,
                info: StyledNotistack,
                success: StyledNotistack,
                warning: StyledNotistack,
                error: StyledNotistack,
                successUpdate: StyledNotistack,
                failUpdate: StyledNotistack
            }}
            // with close as default
            action={(snackbarId) => (
                <IconButton size="small" onClick={() => closeSnackbar(snackbarId)} sx={{ p: 0.5, zIndex: 9 }}>
                    <Iconify width={16} icon="mingcute:close-line"/>
                </IconButton>
            )}
        >
            {children}
        </NotistackProvider>
    );
}

SnackbarProvider.propTypes = {
    children: PropTypes.node
};
